import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api/api.service';

export interface SupportTicket {
  id: number;
  user_id: number;
  user_email?: string;
  user_name?: string;
  ticket_id: string;
  category?: string;
  message: string;
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  email_sent?: boolean;
  created_at: string;
  updated_at?: string;
  admin_notes?: string;
}

export interface TicketsResponse {
  tickets: SupportTicket[];
  total: number;
  page: number;
  page_size: number;
}

export interface TicketStatusUpdate {
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  admin_notes?: string;
}

@Injectable({ providedIn: 'root' })
export class SupportTicketsService {
  constructor(private apiService: ApiService) {}

  /**
   * Get list of all support tickets
   */
  getTickets(
    params?: {
      status?: string;
      page?: number;
      limit?: number;
    },
    skipGlobalLoader = false,
  ): Observable<TicketsResponse> {
    return this.apiService.get<TicketsResponse>('/admin/support-tickets', params, true, skipGlobalLoader);
  }

  /**
   * Get list of tickets as array (for backward compatibility)
   */
  getTicketsArray(
    params?: {
      status?: string;
      page?: number;
      limit?: number;
    },
    skipGlobalLoader = false,
  ): Observable<SupportTicket[]> {
    return this.apiService
      .get<TicketsResponse>('/admin/support-tickets', params, true, skipGlobalLoader)
      .pipe(map((response) => response.tickets));
  }

  /**
   * Get ticket details by ID
   */
  getTicketById(ticketId: number | string, skipGlobalLoader = false): Observable<SupportTicket> {
    return this.apiService.get<SupportTicket>(
      `/admin/support-tickets/${ticketId}`,
      undefined,
      true,
      skipGlobalLoader,
    );
  }

  /**
   * Update ticket status
   */
  updateTicketStatus(
    ticketId: number | string,
    update: TicketStatusUpdate,
  ): Observable<SupportTicket> {
    return this.apiService.patch<SupportTicket>(
      `/admin/support-tickets/${ticketId}/status`,
      update,
    );
  }
}
